// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"82be0d6f","291":"16ad5d0e","321":"6a931ec2","446":"e7ccf13c","757":"6e369f70","830":"38f15aed","941":"626fcf20"}[chunkId] + ".chunk.js";
};